// removed by extract-text-webpack-plugin
module.exports = {"rating":"_3-Rvq","starRating":"_1V8Ka","starRatingCount":"_771gB"};